export const defaultLoader = ({ src, width }: { src: string; width: number }) =>
  `/_next/image?url=${src}&w=${width}&q=75`

export const preloadImageLoader = ({ src, host }: { src?: string; host: string }) => `
  ${host}/_next/image?url=${src}&w=384&q=75`

export const doctifyCDNLoader = ({ src, width }: { src: string; width: number }) =>
  `https://cdn.doctify.com/_next/image?url=${src}&w=${width}&q=75`
